/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteUserSession} from '../api'

export const useMutationDeleteUserSession = createReactQueryMutationHook('deleteUserSession', deleteUserSession)
